// extracted by mini-css-extract-plugin
export default {"cls1":"ImpactHubModal-cls1_B9f","cls2":"ImpactHubModal-cls2_tey ImpactHubModal-cls1_B9f"};